import React from 'react';
import { Button } from './Button';
export const WeeklyBreakdownSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/sPjut2p7/checkout?coupon_code=21OFFNEUROPROGRAMNEWMEMBERS';
  return <section className="bg-gradient-to-b from-teal-600 to-teal-700 text-white py-16" data-id="element-292">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-293">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-294">
          Weekly Breakdown
        </h2>
        <div className="mb-10" data-id="element-295">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iwqzNsRzr4qvCFatQsLDoL/Screen_Shot_2025-06-14_at_8.42.17_AM.png" alt="Weekly course curriculum showing video lessons" className="w-full rounded-lg shadow-xl mb-8" data-id="element-296" />
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-297">
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-298">
            <h3 className="text-xl font-bold mb-3" data-id="element-299">Week 1: Restore Safety</h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-300">
              <li data-id="element-301">Slow, trauma-informed yoga and breath</li>
              <li data-id="element-302">Gentle activation of the vagus nerve</li>
              <li data-id="element-303">Foundation for calm</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-304">
            <h3 className="text-xl font-bold mb-3" data-id="element-305">
              Week 2: Unfreeze Your Body
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-306">
              <li data-id="element-307">Movement meets sound and sensory mapping</li>
              <li data-id="element-308">Tools to safely exit shutdown and dissociation</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-309">
            <h3 className="text-xl font-bold mb-3" data-id="element-310">
              Week 3: Reconnect & Express
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-311">
              <li data-id="element-312">Expressive arts and voice activation</li>
              <li data-id="element-313">Release emotional blocks with movement, not words</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-314">
            <h3 className="text-xl font-bold mb-3" data-id="element-315">
              Week 4: Regulate & Rewire
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-316">
              <li data-id="element-317">Build daily resilience habits</li>
              <li data-id="element-318">
                Develop a personal nervous system toolkit for long-term use
              </li>
            </ul>
          </div>
        </div>
        <div className="flex justify-center" data-id="element-319">
          <Button link={checkoutUrl} data-id="element-320">Begin Week 1 Today ➔</Button>
        </div>
      </div>
    </section>;
};